export const SUPPORTED_FORMULA_KEYWORDS = ['qtyofckg', 'qtyofkg', 'goodsvalue']

export const feeFormula = [
  {
    name: 'type',
    label: 'Type',
    type: 'select',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    clearFields: ['feeCode'],
    hideCode: true,
    width: 150,
  },
  {
    name: 'feeCode',
    label: 'Fee',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    width: 180,
  },
  {
    name: 'rate',
    label: 'Rate',
    type: 'text',
    maxLength: 100,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    width: 150,
  },
  {
    name: 'formula',
    label: 'Formula',
    type: 'text',
    maxLength: 500,
    placeholder: 'e.g. 0.01327 *{qtyofckg}',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    width: 350,
  },
  {
    name: 'printText',
    label: 'Print',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    width: 230,
  },
  {
    name: 'effectiveStartDate',
    label: 'Effective Start Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    width: 200,
  },
  {
    name: 'effectiveEndDate',
    label: 'Effective End Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    width: 200,
  },
]
